'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagKpAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8.88109e-06 0H28C28 6.66667 28 13.3333 28 20H8.88109e-06C5.5918e-06 13.3333 -5.72404e-05 6.66667 8.88109e-06 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 4H28V0H8.88109e-06L0 4Z",
          fill: "#1461B6"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.88109e-06 20H28C28 18.6667 28 17.3333 28 16H0C0 17.3333 -4.34324e-06 18.6667 8.88109e-06 20Z",
          fill: "#1461B6"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 16H28V4H0V16Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 14.6667H28V5.33333H0V14.6667Z",
          fill: "#F53846"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.3332 10C13.3332 11.841 11.8408 13.3334 9.99984 13.3334C8.15889 13.3334 6.6665 11.841 6.6665 10C6.6665 8.15907 8.15889 6.66669 9.99984 6.66669L9.21363 8.9179L6.82965 8.96996L8.72772 10.4134L8.04055 12.6967L9.99984 11.3376L11.9591 12.6967L11.2719 10.4134L13.17 8.96996L10.786 8.9179L9.99984 6.66669C11.8408 6.66669 13.3332 8.15907 13.3332 10Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagKpAsset = forwardRef(FlagKpAsset);

export { VpFlagKpAsset as default };
